export default "__VITE_ASSET__1OjQdw$c__"